import { appActions } from "App/duck";
import { deleteSkill } from "helpers/api-calls/skill-calls";
import { DeleteRole, AddRole, UpdateRole, AssignRolesToUser, RemoveUserFromRole } from "helpers/api-calls/role-calls";
import teamCalls from "helpers/api-calls/team-calls";

const addRoleOperation = (name, color, locationId, selectRoleCallback) => (dispatch) => {
  return AddRole(name, color, locationId)
    .then((response) => {
      dispatch(appActions.appendRole(response.data.tag));
      if(selectRoleCallback) {
        selectRoleCallback(response.data.tag);
      }
    })
    .catch((error) => {
      console.error("Error adding role:", error);
    });
};

const deleteRoleOperation = (roleId, locationId) => (dispatch) => {
  return DeleteRole(roleId, locationId)
    .then(() => {
      const payload = {tagId: roleId}
      dispatch(appActions.removeRole(payload));
    })
    .catch( (error) => {
      console.error("Error deleting role:", error);
    });
};

const updateRoleOperation = (roleId, colorCode, locationId) => (dispatch) => {
  return UpdateRole(roleId, colorCode, locationId)
    .then((response) => {
      dispatch(appActions.updateRole(response.data.tag));
    })
    .catch((error) => {
      console.error("Error updating role:", error);
    });
};

const deleteSkillOperation = (skillId, locationId) => (dispatch) => {
  return deleteSkill(skillId, locationId)
    .then(() => {
      const payload = {skillId: skillId}
      dispatch(appActions.removeSkill(payload));
    })
    .catch((error) => {
      console.error("Error deleting skill:", error);
    });
};

/**
 * Fetch all approved team members for a location.
 * Returns user privileges with user.tag_ids for role membership.
 */
const fetchRolePageMembersOperation = (locationId) => () => {
  return teamCalls.getTeamMembers({
    location_id: locationId,
    page: 1,
    per_page: 10000,
    filter: 'active',
  }).then((response) => {
    return response.data.user_privileges || [];
  }).catch((error) => {
    console.error("Error fetching role page members:", error);
    return [];
  });
};

/**
 * Add a role to a user. Preserves existing tag_ids and appends the new one.
 * After success, returns the updated members list via re-fetch.
 */
const addRoleToUserOperation = (userId, roleId, existingTagIds, locationId) => () => {
  const updatedRoleIds = Array.from(new Set([...(existingTagIds || []), roleId]));
  return AssignRolesToUser(userId, updatedRoleIds, locationId)
    .then(() => {
      return teamCalls.getTeamMembers({
        location_id: locationId,
        page: 1,
        per_page: 10000,
        filter: 'active',
      }).then((response) => {
        return response.data.user_privileges || [];
      });
    })
    .catch((error) => {
      console.error("Error adding role to user:", error);
      return null;
    });
};

/**
 * Remove a role from a user. Filters the roleId out of existing tag_ids.
 * After success, returns the updated members list via re-fetch.
 */
const removeRoleFromUserOperation = (userId, roleId, existingTagIds, locationId) => () => {
  return RemoveUserFromRole(userId, existingTagIds || [], [roleId], locationId)
    .then(() => {
      return teamCalls.getTeamMembers({
        location_id: locationId,
        page: 1,
        per_page: 10000,
        filter: 'active',
      }).then((response) => {
        return response.data.user_privileges || [];
      });
    })
    .catch((error) => {
      console.error("Error removing role from user:", error);
      return null;
    });
};

export default {
  deleteSkillOperation,
  deleteRoleOperation,
  addRoleOperation,
  updateRoleOperation,
  fetchRolePageMembersOperation,
  addRoleToUserOperation,
  removeRoleFromUserOperation,
};

